import { DateCell } from '@/creditflowresearch/ui/common/components/DataCells';
import { FILTER_STATUS_ID_MAP } from '@framework/ui/Organisms/Filters/constants';

interface IDealDateCellProps {
  date: string | null,
  statusId: number,
}

const getDateTooltip = (statusId: number): string => {
  if (statusId === FILTER_STATUS_ID_MAP.priced) {
    return 'Issue Date';
  }
  if (statusId === FILTER_STATUS_ID_MAP.announced) {
    return 'Announced Date';
  }
  return 'Last Updated';
};

const DealDateCell = ({ date, statusId }: IDealDateCellProps) => {
  return (<DateCell value={ date } tooltipContent={ getDateTooltip(statusId) } />);
};

export default DealDateCell;
